<script>
import { getRandomInt, IsNullOrEmpty} from "@/modules/helper/index";
import { mapGetters } from "vuex";
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default() {
        return []
      },
      required: true
    },
    value: {
      type: Array,
       default() {
        return []
      }
    },
    hasDefault: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: ""
    }
  },
  data() {
    return {
     // selectedValue: [],
      selectelement: []
    }
  },
  computed: {
    ...mapGetters(["resource"]),
    randomNo() {
      return getRandomInt()
    },
    selectid() {
      return "smart-select-" + this.randomNo
    },
    selectedValue: {
      get () {
        return this.value
      },
      set (val) {
        if (val.length > 0){
          this.$emit("propChange", { value: val })
        }
      }
    }
  },
  watch: {
          options: function(value, oldvalue) {     
            let valindex = value.filter(x => x.default == true)
            let oldvalindex = oldvalue.filter(x => x.default == true)     
              if (valindex.length !== oldvalindex.length) {
                   this.selectedValue = []
                   this.setDefault()
                 } 
         }
  },
  mounted() {
    this.setDefault()
  },
  methods: {
    onChange() {
      this.selectelement =this.$refs[this.selectid].f7SmartSelect
      let array = Array.from(this.selectelement.selectEl.selectedOptions)
      let selectedOptions = [] 
      array.forEach(val => {
        selectedOptions.push(val.value)
      })
      this.SelectedValueArray = selectedOptions
      this.selectedValue = selectedOptions
    },
    setDefault() {
      if (this.hasDefault && this.value.length === 0) {
           let sv = this.options.filter(option => option.default === true).map(o => o.text)
           this.selectedValue.push(...sv)
           if (this.selectedValue.length !== 0){
             this.$emit("propChange", { value: this.selectedValue })
           }
        }
    },
    isSelected(val) { 
       if (this.selectedValue.length === 0){
         this.setDefault()  
       }
       else {
          return this.selectedValue.includes(val)
       }
    }
  },
  beforeDestroy() {
     this.selectedValue = []
  }

};
</script>
<template>
<f7-list>
   <f7-list-item :ref="selectid" smart-select :smart-select-params="{ searchbar: true , routableModals: true , pageBackLinkText: resource.backBtn  }" title="">
    <f7-label class="label-color label-width">{{label}}</f7-label>
      <select name=""  :id="selectid" v-on:change="onChange()" :placeholder="placeholder" class="no-fastclick"  multiple="multiple">
        <option  v-for="(option, index) in options"
         :key="index"
         :title="option.text"        
         :value="option.text"
         :checked="isSelected(option.text)"
         :selected="isSelected(option.text)">
         {{option.text}}
         </option>
    </select>
  </f7-list-item>
 </f7-list>  
</template>
<style scoped>
  .list {
    margin: 15px 0;
  }
  .searchbar {
    height: 48px;
    background: #fff;
  }
  .item-label {
    line-height: 15px !important;
  }
  .label-width {
    width: 40% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/SmartSelectList.vue